// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#1890FF","primaryColorDark":"#0C5FC1","primaryColorLight":"#D3EAFF","searchHighlightColor":"search-highlight-color"};